import { render, staticRenderFns } from "./UsagePoliciesPageContent.vue?vue&type=template&id=95f98a3a&scoped=true&"
import script from "./UsagePoliciesPageContent.vue?vue&type=script&lang=js&"
export * from "./UsagePoliciesPageContent.vue?vue&type=script&lang=js&"
import style0 from "./UsagePoliciesPageContent.vue?vue&type=style&index=0&id=95f98a3a&lang=scss&scoped=true&"
import style1 from "./UsagePoliciesPageContent.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95f98a3a",
  null
  
)

export default component.exports